import Cookie from 'js-cookie'
import NProgress from 'nprogress' // progress bar
import 'nprogress/nprogress.css' // progress bar style
import { homePageRoutes, personRoutes } from '@/router'
import store from './store'

NProgress.configure({ showSpinner: false }) // NProgress Configuration
//
// 定义权限检查函数，而不是直接执行
export function createPermissionGuard (router) {
  // 白名单路由，无需登录即可访问
  //   const whiteList = ['/', '/index', '/custom', '/activity', '/store', '/productDetail'] // 根据实际需要添加
  let loginRequiredRoutes = [...homePageRoutes, ...personRoutes].map(route => route.path)
  router.beforeEach((to, from, next) => {
    NProgress.start()
    // 获取用户登录状态
    const hasToken = Cookie.get('token')

    if (hasToken) {
         // 检查当前路由是否属于用户中心路由
      const isPersonRoute = personRoutes.some(route => route.path === to.path)
      const isHomePageRoute = homePageRoutes.some(route => route.path === to.path)
        if (isPersonRoute) {
            store.commit('SET_PERSONROUTES', personRoutes)
          } else if (isHomePageRoute) {
            store.commit('SET_HOMEPAGEROUTES', homePageRoutes)
          } else {}
        // 已登录状态
        //   if (to.path === '/login') {
        //     // 如果已登录又访问登录页，则重定向到首页
        //     next({ path: '/' })
        //   } else {
        //     // 检查用户权限或其他逻辑
        //     // 这里可以添加更复杂的权限验证逻辑
        next()
        NProgress.done()
    //   }
    } else {
      // 未登录状态
      if (!(loginRequiredRoutes.indexOf(to.path) !== -1)) {
        // 在免登录白名单，直接进入
        next()
      } else {
        // 其他页面重定向到登录页
        // 如果项目中没有登录页，可以先注释掉或指定一个实际存在的页面
        next({ path: '/' }) // 暂时跳转到首页
        store.commit('SHOW_LOGIN')
      }
    NProgress.done()
    }
  })
}



// WEBPACK FOOTER //
// ./src/permission.js